/** A comparison holds workspaces or listings, never both. */
export enum CompareType {
    WORKSPACE = 'workspace',
    LISTING = 'listing'
}

/**
 * Where a comparison table was opened from. Drives the back button label and
 * destination, and the `entry_point` / `destination` tracking values.
 */
export enum CompareEntryPoint {
    EXPLORE = 'explore',
    WORKSPACE_DETAILS = 'workspace_details',
    LISTING_DETAILS = 'listing_details',
    /** Listing table opened from "Compare Listings (x)" on the workspace table. */
    WORKSPACE_TABLE = 'workspace_table'
}

/** Sort columns options. Values double as the URL `sort` param and tracking value. */
export enum CompareSortOption {
    PRICE_LOW_HIGH = 'price_low_high',
    PRICE_HIGH_LOW = 'price_high_low',
    RATING_HIGH_LOW = 'rating_high_low',
    MOST_REVIEWED = 'most_reviewed',
    NEAREST_FIRST = 'nearest_first',
    LARGEST_CAPACITY = 'largest_capacity',
    LARGEST_AREA = 'largest_area'
}

/** Sort options the workspace table offers (it has no Space rows). */
export const WORKSPACE_SORT_OPTIONS: CompareSortOption[] = [
    CompareSortOption.PRICE_LOW_HIGH,
    CompareSortOption.PRICE_HIGH_LOW,
    CompareSortOption.RATING_HIGH_LOW,
    CompareSortOption.MOST_REVIEWED,
    CompareSortOption.NEAREST_FIRST
];

export const LISTING_SORT_OPTIONS: CompareSortOption[] = Object.values(
    CompareSortOption
);

/**
 * Row ids for "Rows shown". Values are used in the URL `hide` param and as the
 * `row` tracking value, so keep them stable.
 */
export enum CompareRowId {
    LISTINGS = 'listings',
    PRICE_DAY = 'price_day',
    PRICE_MONTH = 'price_month',
    INSTANT_BOOKING = 'instant_booking',
    PAYMENT = 'payment',
    RATING = 'rating',
    REVIEWS = 'reviews',
    CAPACITY = 'capacity',
    AREA = 'area',
    CITY = 'city',
    DISTANCE = 'distance',
    AMENITIES = 'amenities'
}

/** Rate units, shortest to longest — the order "Other rates" tags use. */
export enum CompareRateUnit {
    HOUR = 'hour',
    DAY = 'day',
    MONTH = 'month',
    YEAR = 'year'
}

export const RATE_UNIT_ORDER: CompareRateUnit[] = [
    CompareRateUnit.HOUR,
    CompareRateUnit.DAY,
    CompareRateUnit.MONTH,
    CompareRateUnit.YEAR
];

// --- Tracking value sets (PRD § Tracking) ---

export enum CompareAddSource {
    EXPLORE = 'explore',
    ADD_POPUP = 'add_popup',
    WORKSPACE_TABLE = 'workspace_table'
}

export enum CompareRemoveSource {
    EXPLORE_CARD = 'explore_card',
    EXPLORE_BAR = 'explore_bar',
    ADD_POPUP = 'add_popup',
    TABLE_CHIP = 'table_chip',
    WORKSPACE_TABLE = 'workspace_table',
    LISTINGS_BAR = 'listings_bar'
}

export enum CompareExitMethod {
    COMPARE_BUTTON = 'compare_button',
    CANCEL = 'cancel',
    ESC = 'esc'
}

export enum CompareViewSource {
    LISTING_TABLE = 'listing_table',
    WORKSPACE_TABLE = 'workspace_table',
    ALL_LISTINGS = 'all_listings'
}

export enum CompareBookSource {
    COLUMN_BUTTON = 'column_button',
    PRICE_LINE = 'price_line',
    ALL_LISTINGS = 'all_listings'
}

/** `compare_error.screen`: where a load failed. */
export enum CompareErrorScreen {
    EXPLORE = 'explore',
    WORKSPACE_TABLE = 'workspace_table',
    LISTING_TABLE = 'listing_table',
    ADD_POPUP = 'add_popup',
    ALL_LISTINGS = 'all_listings'
}
